import React from 'react';
import styled from 'styled-components';
import { compact, reject } from 'lodash';
import { useGetHandSizes } from '../hooks';
import { User } from '../types';
import { UserId } from '../containers/UserId';
import { H2 } from './Layout';

export const HandSizes: React.FC<{ users: User[], roomId: string, className?: string }> = ({
    users,
    roomId,
    className,
}) => {
    const { handSizes } = useGetHandSizes(roomId);
    const { userId } = UserId.useContainer();
    const filteredUsers = reject(users, { userId });
    console.log(users, userId);
    return filteredUsers.length ? (
        <div className={className}>
            <div>User Tiles</div>
            {compact(
                filteredUsers.map(({ userName, userId }) => {
                    // This error handling is wrong
                    // shouldn't default to 0...
                    const handSize = handSizes?.[userId] || 0;
                    return (
                        <div key={userId}>
                            {userName}: {handSize}
                        </div>
                    );
                }),
            )}
        </div>
    ) : null;
};

